import { useEffect, useState } from "react";

const KEY = "pdn_compare_v1";
const MAX = 4;

const readList = (): string[] => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
};

const writeList = (list: string[]) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("pdn-compare-change"));
  } catch {
    // ignore
  }
};

export const compareStore = {
  get: readList,
  has: (slug: string) => readList().includes(slug),
  toggle: (slug: string) => {
    const list = readList();
    const idx = list.indexOf(slug);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX) return false;
      list.push(slug);
    }
    writeList(list);
    return true;
  },
  remove: (slug: string) => {
    writeList(readList().filter((s) => s !== slug));
  },
  clear: () => writeList([]),
  MAX,
};

export const useCompare = () => {
  const [list, setList] = useState<string[]>(() => readList());
  useEffect(() => {
    const onChange = () => setList(readList());
    window.addEventListener("pdn-compare-change", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("pdn-compare-change", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  return list;
};
